export default __webpack_public_path__ + "static/Duplo-d4d139a048657f297418ed47f035ab4a.svg";